/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/UserStore/store.js'
import './registerServiceWorker'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import './styles/style.scss'
import VueProgressBar from 'vue-progressbar'

Vue.use(require('vue-moment'));

Vue.use(Buefy, {
    defaultIconPack: 'mdi'
})

Vue.use(VueProgressBar, {
    color: 'rgb(255,71,15)',
    failedColor: 'red',
    height: '10px'
})
Vue.config.productionTip = false

const websiteTitle = "David Mouat Thomson"

router.beforeEach((to, from, next) => {
    next();
});

router.afterEach((to, from) => {
    window.scrollTo(0, 0);
    if (to.meta && to.meta.title) {
        document.title = `${to.meta.title} - ${websiteTitle} `;
    }
})

new Vue({
    router,
    store,
    el: '#app',
    render: h => h(App),
});
